import { type LabColorInput, toLabColor } from './toLabColor'

// Chip keys from CROWN_BUTTON_WITH_COLOR are the StainingPurpose enum values.
export const STAINING_PURPOSE_BY_CHIP_KEY: Record<string, string> = {
  Cervical: 'Cervical',
  Middle: 'Middle',
  Incisal: 'Incisal',
  'Light Absorption': 'Light Absorption',
  'Light Reflection': 'Light Reflection',
  'Mamelon/Halo': 'Mamelon/Halo',
  'Amber Opal': 'Amber Opal',
  'Enamel Effect': 'Enamel Effect',
  'Blue Opal': 'Blue Opal',
}

export const toStainingPurpose = (
  chipKey: string | null | undefined,
): string => {
  if (!chipKey) return ''
  return STAINING_PURPOSE_BY_CHIP_KEY[chipKey] ?? chipKey
}

export const buildStainingWithEnamelPayload = ({
  stainingbrand,
  protocol,
  fullmonolithiceffect,
  backgroundcolor,
  targetcolor,
}: {
  stainingbrand?: string | null
  protocol?: string
  fullmonolithiceffect?: string | null
  backgroundcolor?: LabColorInput | null
  targetcolor?: LabColorInput | null
}): Record<string, unknown> => {
  const background = toLabColor(backgroundcolor)
  const target = toLabColor(targetcolor)

  return {
    stainingbrand: stainingbrand || '',
    protocol,
    fullmonolithiceffect: toStainingPurpose(fullmonolithiceffect),
    ...(background ? { backgroundcolor: background } : {}),
    ...(target ? { targetcolor: target } : {}),
  }
}
